import { Link, createFileRoute } from '@tanstack/react-router'
import type { ReactNode } from 'react'
import { AccountLink } from '../components/AccountLink'
import { ButtonLink, Label, PageTitle } from '../components/ui'
import { meQuery } from '../lib/queries'

// The terms page (sc-2115, designs/20261012-dmca-basics.md §5): a few plain
// paragraphs, not a lawyer's template. The words are Ryan's; change UPDATED
// with them. It repeats nothing of /privacy and leaves the copyright process
// to /copyright.
const UPDATED = 'October 13, 2026'

export const Route = createFileRoute('/terms')({
  // Anyone can read this page, signed in or not (as /privacy): the sign-up
  // screen links here.
  beforeLoad: ({ context }) => context.queryClient.ensureQueryData(meQuery).catch(() => undefined),
  component: Terms,
})

const link = 'font-semibold text-ink underline underline-offset-2'

function Section({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="grid gap-2.5">
      <Label>{title}</Label>
      <div className="grid gap-2.5 text-[15px] text-muted">{children}</div>
    </section>
  )
}

function Terms() {
  return (
    <div className="mx-auto grid w-full max-w-[560px] gap-5 px-4 pb-16 pt-[calc(env(safe-area-inset-top,0px)+24px)]">
      <div className="flex items-start justify-between gap-3">
        <PageTitle eyebrow="Terms">The short list of rules</PageTitle>
        <AccountLink className="mt-1 flex-none" />
      </div>
      <p className="text-[15.5px]">Cat Bowl is a weekly cat photo contest for groups of friends. By making an account you agree to what is on this page. It is short on purpose.</p>
      <Section title="What you post">
        <p>Only post what you made or may share. Your photos and videos stay yours. By posting one you let us store it and show it to the members of the league you posted it in, and that is all we do with it.</p>
      </Section>
      <Section title="What we may do">
        <p>We may remove a post or close an account: when a copyright notice against it stands, or when something spoils the league for the others. The <Link to="/copyright" className={link}>Copyright</Link> page has the process, and the rule that two such notices close an account.</p>
      </Section>
      <Section title="What this is">
        <p>A hobby project that one person runs for friends. It is free, and it comes with no promise that it stays up, works every day or keeps what you posted. Keep your own copies of the photos you care about.</p>
        <p>What we store about you, and how to delete it, is on the <Link to="/privacy" className={link}>Privacy</Link> page.</p>
      </Section>
      <Section title="Changes">
        <p>If these terms change, the date below changes with them.</p>
      </Section>
      <p className="text-[13px] text-muted">Last updated {UPDATED}.</p>
      <div className="flex flex-wrap gap-2.5">
        <ButtonLink to="/" size="sm">Back to the league</ButtonLink>
        <ButtonLink to="/privacy" size="sm">Privacy</ButtonLink>
        <ButtonLink to="/copyright" size="sm">Copyright</ButtonLink>
      </div>
    </div>
  )
}
